<template>
<div>
  <custom-header></custom-header>
  <section class="content">
    <div class="columns">
      <div class="column is-half">

      </div>
    </div>
  </section>
</div>
</template>

<script>
import CustomHeader from './CustomHeader'
export default {
  name: 'hello',
  components: {
    CustomHeader
  },
  data () {
    return {
      msg: 'Biya'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo {
    width: 200px
  }
</style>



// WEBPACK FOOTER //
// Hello.vue?922bd7bc